import { SettingsCache } from '~/lib/consts/settings-cache';
import { CustomerType } from './CustomerType';
import { Individual, NotRegistered, Registered } from '~/apps/smartsend/lib/consts/TaxStatusConsts';

const BusinessVatStatuses = [Registered, NotRegistered];
const IndividualVatStatuses = [Individual];

export const GetSignupVatStatusOptions = (customerType: CustomerType, isBusiness: boolean) => {
  const options = GetVatStatuses(customerType);

  if (isBusiness && options.some((o) => BusinessVatStatuses.includes(o))) {
    return options.filter((o) => BusinessVatStatuses.includes(o));
  }

  if (!isBusiness && options.some((o) => IndividualVatStatuses.includes(o))) {
    return options.filter((o) => IndividualVatStatuses.includes(o));
  }

  return options;
};

const GetVatStatuses = (customerType: CustomerType) => {
  const vatStatusList = [Individual, Registered, NotRegistered];

  if (customerType === 'Sender') {
    const senderPersonalOptionFeature = SettingsCache.settings.Features?.includes('SenderPersonalOption');

    return senderPersonalOptionFeature ? vatStatusList : vatStatusList.filter((x) => x !== Individual);
  } else if (customerType === 'Recipient') {
    return vatStatusList;
  }

  return vatStatusList;
};

export const GetDefaultVatStatus = (customerType: CustomerType) => {
  const options = GetVatStatuses(customerType);
  if (options.some((o) => o === Individual)) {
    return Individual;
  } else if (options.some((o) => o === NotRegistered)) {
    return NotRegistered;
  }
  return '';
};

export const GetAllowedVatStatus = (customerType: CustomerType, currentStatus: string | undefined) => {
  const options = GetVatStatuses(customerType);
  if (options.some((o) => o === currentStatus)) {
    return currentStatus;
  }
  if (options.some((o) => o === Individual)) {
    return Individual;
  } else if (options.some((o) => o === NotRegistered)) {
    return NotRegistered;
  }
  return currentStatus;
};

export default GetVatStatuses;
